import { useEffect } from 'react';
import {
  Toaster,
  makeStyles,
  useId,
  useToastController,
} from '@fluentui/react-components';
import { bindToastDispatch } from './toast';

const useStyles = makeStyles({
  toaster: {
    zIndex: 2000000,
    width: 'min(520px, calc(100vw - 32px))',
  },
});

const ToastHost = () => {
  const styles = useStyles();
  const toasterId = useId('toaster');
  const { dispatchToast } = useToastController(toasterId);

  useEffect(() => {
    return bindToastDispatch((content, { timeoutMs, intent }) => {
      dispatchToast(content, {
        intent,
        timeout: timeoutMs ?? -1,
        pauseOnHover: true,
      });
    });
  }, [dispatchToast]);

  return (
    <Toaster toasterId={toasterId} position="top" className={styles.toaster} />
  );
};

export default ToastHost;
